import React from 'react';
import { useLocation } from 'react-router-dom';
import BottomNav from './BottomNav';
import ContactFab from './ContactFab';
import DashboardShortcut from './DashboardShortcut';
import { useAuth } from '../lib/auth';

const HIDE_ROUTES = ['/login', '/register', '/auth-callback'];
const DESKTOP_ROUTES = ['/admin', '/partner'];
// ContactFab is hidden on chat pages (the order detail page has its own send/chat controls
// and the FAB was overlapping the send button).
const HIDE_CONTACT_FAB = [/^\/orders\/[^/]+/];

const MobileFrame = ({ children }) => {
  const { pathname } = useLocation();
  const { user } = useAuth() || {};

  const hideNav = HIDE_ROUTES.some(r => pathname.startsWith(r));
  const isDashboard = DESKTOP_ROUTES.some(r => pathname.startsWith(r));
  const hideContactFab = HIDE_CONTACT_FAB.some(r => r.test(pathname));

  if (isDashboard) return <>{children}</>;

  return (
    <div
      className="pk-frame-shell"
      style={{ background: 'radial-gradient(circle at 25% 15%, #ffe9f4 0, transparent 40%), radial-gradient(circle at 85% 85%, #e0f7ff 0, transparent 45%), #f5f5f5' }}
    >
      <div className="pk-frame-center">
        <div
          className="pk-frame-device relative bg-white pk-border-thick brutal-shadow-lg overflow-hidden"
          data-testid="mobile-frame"
        >
          {/* CMYK tiny registration marks — brand element, always in front */}
          <div className="pointer-events-none absolute top-0 left-3 w-2 h-2 z-40" style={{ background: '#00a3e0' }} />
          <div className="pointer-events-none absolute top-0 left-7 w-2 h-2 z-40" style={{ background: '#e30066' }} />
          <div className="pointer-events-none absolute top-0 left-11 w-2 h-2 z-40" style={{ background: '#ffd700' }} />
          <div className="pointer-events-none absolute top-0 left-[60px] w-2 h-2 z-40" style={{ background: '#0a0a0a' }} />

          <div className="absolute inset-0 flex flex-col">
            <div className="flex-1 overflow-y-auto" style={{ paddingBottom: hideNav ? 0 : 72, WebkitOverflowScrolling: 'touch' }}>
              {children}
            </div>
            {!hideNav && user && user.role === 'customer' && <BottomNav />}
            {!hideNav && user && (user.role === 'admin' || user.role === 'partner') && <DashboardShortcut role={user.role} />}
          </div>

          {!hideNav && !hideContactFab && (!user || user.role === 'customer') && <ContactFab />}
        </div>
      </div>
    </div>
  );
};

export default MobileFrame;
